export default "__VITE_ASSET__CglvOqCn__"